import React, { useState, useEffect } from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Button, Typography, Box, IconButton, Chip, Tooltip
} from '@mui/material';
import { Edit, Delete, Visibility, Add } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { offerService } from '../services/api';
import SkeletonBlock from './ui/SkeletonBlock';
import EmptyState from './ui/EmptyState';
import { useConfirm } from './Common/ConfirmDialog';

function OfferList() {
  const confirm = useConfirm();
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    try {
      const response = await offerService.getAll();
      console.log('Offers API response:', response);
      setOffers(response || []);
    } catch (error) {
      console.error('Error fetching offers:', error);
      setOffers([]); // Ensure offers is always an array
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (await confirm({ message: 'Are you sure you want to delete this offer?', danger: true, confirmLabel: 'Delete' })) {
      try {
        await offerService.delete(id);
        fetchOffers();
      } catch (error) {
        console.error('Error deleting offer:', error);
      }
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Accepted': return 'success';
      case 'Declined': return 'error';
      case 'Pending': return 'warning';
      default: return 'default';
    }
  };

  if (loading) return <SkeletonBlock rows={6} />;

  if (!loading && offers.length === 0) {
    return <EmptyState title="No offers" description="There are no offers yet." actionLabel="Add New Offer" onAction={()=>{ window.history.pushState({}, '', '/offers/new'); window.dispatchEvent(new PopStateEvent('popstate')); }} />;
  }

  return (
    <Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h4">Employment Offers</Typography>
        <Button
          variant="contained"
          startIcon={<Add />}
          component={Link}
          to="/offers/new"
        >
          Add New Offer
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{ maxHeight: 560 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Offer Number</TableCell>
              <TableCell>Candidate Name</TableCell>
              <TableCell>Position</TableCell>
              <TableCell>Offer Date</TableCell>
              <TableCell>Start Date</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {offers.map((offer) => (
              <TableRow key={offer.id} hover>
                <TableCell>{offer.offerNumber}</TableCell>
                <TableCell>{offer.candidateFullName}</TableCell>
                <TableCell>{offer.offeredPosition}</TableCell>
                <TableCell>{new Date(offer.offerDate).toLocaleDateString()}</TableCell>
                <TableCell>{new Date(offer.offeredStartDate).toLocaleDateString()}</TableCell>
                <TableCell>
                  <Chip
                    label={offer.offerStatus}
                    color={getStatusColor(offer.offerStatus)}
                    size="small"
                  />
                </TableCell>
                <TableCell>
                  <Tooltip title="View" placement="top"><IconButton aria-label="view offer" component={Link} to={`/offers/${offer.id}`}><Visibility /></IconButton></Tooltip>
                  <Tooltip title="Edit" placement="top"><IconButton aria-label="edit offer" component={Link} to={`/offers/${offer.id}/edit`}><Edit /></IconButton></Tooltip>
                  <Tooltip title="Delete" placement="top"><IconButton aria-label="delete offer" onClick={() => handleDelete(offer.id)} color="error"><Delete /></IconButton></Tooltip>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

export default OfferList;